export default __webpack_public_path__ + "locales/de/DataReassignmentDialog.json?hash=5d556d174ebd291d98cd7ca49284fab9";